import type { Listing } from '@thevillages/schemas';

import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { ComputedListingBaths } from '../../../computed-values/listing/baths';

@Component({
  imports: [DecimalPipe],
  selector: 'app-listing-details-features',
  styleUrl: './features.css',
  templateUrl: './features.html',
})
export class ListingDetailsFeatures {
  public readonly listing = input.required<Listing>();

  protected readonly baths = computed(() => ComputedListingBaths(this.listing()));
}
